import React, {Component} from "../../lib/react"
import { DatePicker } from 'antd'
import TimeAgo from "../TimeAgo"
import moment from 'moment'
import './DateTime.less';

export default class DateTime extends Component {
  constructor(props) {
    super(props)
    this.state = {
      date: this.props.item.date || moment(new Date())
    }
  }

  dateHandler (dateSelected) {
    if (dateSelected) {
      dateSelected.set({ hour:2, minute:0, second:0, millisecond:0 })
      this.setState({date: dateSelected})
      this.props.dateChange(dateSelected)
    } else {
      let date = new Date()
      let afterWeekFromCurrentDay = date.setTime(date.getTime() + (7 * 24 * 60 * 60 * 1000))
      this.setState({date: dateSelected})
      this.props.dateChange(moment(new Date(afterWeekFromCurrentDay)))
    }
  }

  onChangeDate(dateSelected) {
    let currentMoment = moment(new Date())
    this.dateHandler(dateSelected || currentMoment)
  }

  render() {
    const { isUpcoming } = this.props.item;
    const { date } = this.state;

    if (isUpcoming && this.props.editing) {
      return (
        <div className="date">
          <DatePicker
            value={moment(date)}
            onChange={(dateSelected) => this.onChangeDate(dateSelected)}
            disabledDate={currentDate => currentDate < moment() }
          />
        </div>
      )
    } else if (!isUpcoming && this.props.editing) {
      return (
        <div className="date">
          <DatePicker
            defaultValue={moment(date)}
            onChange={(dateSelected) => this.dateHandler(dateSelected)}
            disabledDate={currentDate => currentDate > moment() }
          />
        </div>
      )
    } else {
      return (
        <div className="date">
          <p>Event date:</p>
          <TimeAgo date={date}/>
        </div>
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Items/DateTime.js